import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-common/printer";
import * as z from "zod";

export const printCommercialInvoices = {
  name: "printCommercialInvoices" as const,
  input: z.intersection(
    z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
    z.object({
      printerId: z.number().optional(),
      printerOptions: PrinterOptionsSchema.optional(),
      idempotencyKey: z.string().optional(),
    }),
  ),
  output: z.object({ url: z.string(), batchFailed: z.boolean().nullish() }),
};

export type PrintCommercialInvoiceInput = z.infer<
  typeof printCommercialInvoices.input
>;
